import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appLet]',
})
export class AppLetDirective<T> {
  private context = { $implicit: null as T, appLet: null as T };

  @Input()
  set appLet(value: T) {
    this.context.$implicit = this.context.appLet = value;
  }

  constructor(
    vcr: ViewContainerRef,
    templateRef: TemplateRef<any>
  ) {
    vcr.createEmbeddedView(templateRef, this.context);
  }
}